var axios = require('axios');
var sjcl = require('sjcl');

var axiosInstance = axios.create({
  // baseURL: 'http://localhost:5005/foxtrot',
  // baseURL: 'http://20.197.5.130:5005/foxtrot',
  // baseURL: 'http://10.217.60.94:5000/foxtrot',
  baseURL: 'https://msiloptirun.in/foxtrot',
  // baseURL: 'http://msil.optirun.in/foxtrot',
  /* other custom settings */
});

const key='McKtSdj3uVBABcCK8kGLRNtUxXtNMOEsmUPxQwNI4uo='


// User Activities (2026-10-09): write routes whose pages did not send who is acting, so the
// activity row was blank. Identity is ADDED here (from localStorage) only for these routes and only
// for keys the page did not send itself. Deliberately an allow-list: several READ routes use the
// whole request body as the Mongo filter, so adding keys to every request would break them.
var ACTIVITY_IDENTITY_URLS = [
  "/lmconsignees/saveBulkLmHubSOBData", "/lmconsignees/savelmshareofbusiness", "/lmconsignees/savebulklmshareofbusiness",
  "/lmconsignees/savebulklmapprovedsob", "/lmconsignees/updatesharebusiness", "/lmconsignees/updateLmShareBusiness",
  "/lmconsignees/updatelmloadshare", "/lmconsignees/savebulknewlmloadshare", "/lmconsignees/resetLmLoadShare",
  "/lmconsignees/syncLmLoadShare", "/lmconsignees/updateCourierLoadShareData", "/lmconsignees/generateLoadBySOB",
  "/lmconsignees/savebulklmstates", "/lmconsignees/savelmvehiclecapacity", "/lmconsignees/updateHubTransporter",
  "/lmconsignees/saveBulkLmHubLoadShare",
  // master CRUD + main operations logged route-level in Node (lmconsignees.routes.js activityLogger)
  "/lmconsignees/saveConsigneeDetails", "/lmconsignees/statusChangeofConsignee", "/lmconsignees/updateFreightType",
  "/lmconsignees/savelmbaseconfig", "/lmconsignees/saveWarehouseConfig", "/lmconsignees/savelmloadingports",
  "/lmconsignees/saveAirCourierOrderType", "/lmconsignees/deleteAirCourierOrderType", "/lmconsignees/saveAirCourierFloor",
  "/lmconsignees/deleteAirCourierFloor", "/lmconsignees/updateLmTruckAvailability", "/lmconsignees/resetLmTrucksDetails",
  "/lmconsignees/savebulkLmTrucksDetails", "/lmconsignees/saveLmTrucksDetails", "/lmconsignees/savemanualvehicleavailability",
  "/lmconsignees/updateusevehicleavailabilityornot", "/lmconsignees/generateLoadByTransactionId",
  "/lmconsignees/generateLoadByRecommendations", "/lmconsignees/generatelmvoutput", "/lmconsignees/setTruckloadApproval",
  "/lmconsignees/bulkUploadsystemvsmanualdata", "/lmconsignees/triggerScriptForInputPlanData",
  "/lmconsignees/fetchMGPAPIDataAndtriggerScriptForInputPlanData", "/lmconsignees/truckload/uploadPlanData",
  "/lmconsignees/truckload/deleteTruckloadPlanRow", "/lmconsignees/truckload/startTripLoading",
  "/lmconsignees/truckload/finishTripLoading"
];
function addActivityIdentity(req){
  if(ACTIVITY_IDENTITY_URLS.indexOf(req.url) < 0) return;
  var body = req.data;
  if(body === undefined || body === null) body = {};
  var identity = {
    comp_code: localStorage.getItem("comp_code"), user_name: localStorage.getItem("username"),
    staff_id: localStorage.getItem("staff_id"), user_department: localStorage.getItem("lm_department"),
    email: localStorage.getItem("email"), user_role: localStorage.getItem("roles"),
    designation: localStorage.getItem("designation")
  };
  // FormData (file uploads): append only the fields the page did not append itself.
  if(typeof FormData !== "undefined" && body instanceof FormData){
    Object.keys(identity).forEach(function(k){
      if(!body.has(k) && identity[k] !== null && identity[k] !== undefined) body.append(k, identity[k]);
    });
    return;
  }
  if(typeof body !== "object" || Array.isArray(body)) return;
  Object.keys(identity).forEach(function(k){
    var v = body[k];
    if((v === undefined || v === null || v === "") && identity[k] !== null && identity[k] !== undefined){
      body[k] = identity[k];
    }
  });
  req.data = body;
}

axiosInstance.interceptors.request.use(
  function(req){
    addActivityIdentity(req);
    var formdataUrls=["/lmconsignees/generateLoad","/applogin","/registration","/consignments/otpSuccess","/masters/changepassword","/consignments/otpSuccess",
      "/masters/resetpassword","/lmconsignees/generatelmvoutput","/lmconsignees/savebulklmvehiclecapacity","/lmconsignees/savebulklmtransporters","/lmconsignees/savebulklmsobzones",
    "/lmconsignees/savebulklmapprovedsob","/lmconsignees/savebulklmrouteconfig","/lmconsignees/savebulknewlmloadshare","/lmconsignees/savebulklmloadingports",
  "/lmconsignees/savebulklmfreights","/lmconsignees/savebulkLmTrucksDetails","/lmconsignees/savebulklmstates","/lmconsignees/savebulklmshareofbusiness","/lmconsignees/savebulklmconsignees","/authenticateUserToken"]
    if (formdataUrls.includes(req.url) ){
      return req
    }else{
      if(req.data!==undefined){
      var params=sjcl.encrypt(key,JSON.stringify(req.data))
      req.data={encryptedparams:params}
      }else{
        var params=sjcl.encrypt(key,JSON.stringify({}))
        req.data={encryptedparams:params}
      }
      return req
    }
  },function(error){
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log('Response data:', response.data);
    if(response.data.encrypted_res !== undefined){
      var output=sjcl.decrypt(key,response.data.encrypted_res)
      response.data=JSON.parse(output) 
    }
    // console.log(response.data,'helo')
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // console.error('Response interceptor error:', error);
    return Promise.reject(error);
  }
);

module.exports = axiosInstance;
